<template>

    <Head titulo="Lugares de Interés" />
    <HeadTurismo />
    <div class="contenido-wrapper pb-0">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="breadcrumb-block-wrapper">
                        <ul class="breadcrumb-block">
                            <li class="breadcrumb-block__item">
                                <a href="/turismo" class="breadcrumb-block__section">Turismo</a>
                            </li>
                            <li class="breadcrumb-block__item active">
                                <span class="breadcrumb-block__section">Lugares de interés</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="bloque-general bloque-info-img">
            <div class="container">
                <div class="row flex-md-row-reverse">
                    <div class="col-md-7">
                        <h2 class="bloque-encabezado">Explora el increíble atractivo de Santiago</h2>
                        <div class="bloque-descripcion">
                            <p>Descubre Santiago, un Pueblo Mágico que se encuentra a tan <strong>sólo 30 minutos de Monterrey</strong>. Aquí te esperan increíbles paisajes naturales, atracciones perfectas para los amantes de los deportes extremos y el cañonismo, además de una exquisita gastronomía y muchos lugares más para disfrutar en grande.</p>
                        </div>
                    </div>
                    <div class="col-md-5">
                        <div class="bloque-info-img__img">
                            <img loading="lazy" width="278" height="245" src="/img/test-lugares-interes-1.png"
                                alt="Atractivos turísticos de Santiago">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="bloque-general">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <h3 class="encabezado-separador"><span>Próximos eventos</span></h3>
                    </div>
                </div>
                <div class="row justify-content-center">
                    <EventoBox :item="item" v-for="(item, index) in eventos" :key="index" class="col-md-6 col-lg-4" />
                </div>
            </div>
        </div>
        <div class="bloque-general">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <h3 class="encabezado-separador"><span>Espacios culturales</span></h3>
                    </div>
                </div>
                <LugaresBox :lugares="espacios.culturales" :derecha="true" />
            </div>
        </div>
        <div class="bloque-general">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <h3 class="encabezado-separador"><span>De paseo</span></h3>
                    </div>
                </div>
                <LugaresBox :lugares="espacios.paseo" :derecha="false" />
            </div>
        </div>
        <div class="bloque-general">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <h3 class="encabezado-separador"><span>De aventura</span></h3>
                    </div>
                </div>
                <LugaresBox :lugares="espacios.aventura" :derecha="true" />
            </div>
        </div>
        <!-- Map -->
        <div class="bloque-general">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <h3 class="encabezado-separador"><span>Lugares de Interés</span></h3>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="bloque-ubicaciones">
                            <div class="bloque-ubicaciones__mapa">
                                <GMapMap :center="center" :zoom="zoom" style="width: 100%;" :options="{
                                    zoomControl: true,
                                    mapTypeControl: false,
                                    scaleControl: false,
                                    streetViewControl: false,
                                    rotateControl: false,
                                    fullscreenControl: false,
                                }">
                                    <GMapMarker :key="index" v-for="(m, index) in lugares"
                                        :position="{ lat: m.latitude, lng: m.longitude }" :clickable="true"
                                        :draggable="false" @click="clickMarker(m)">
                                        <GMapInfoWindow :closeclick="false"
                                            :title="m.nombre" :opened="openedMarkerID == m.id">
                                            <div class="title-marker">{{ m.nombre }} </div>
                                            <!--<div class="desc-marker">{{ m.informacion_corta }} </div>-->
                                        </GMapInfoWindow>
                                    </GMapMarker>
                                </GMapMap>
                            </div>
                            <div class="bloque-ubicaciones__sidebar" v-if="!openInfo">
                                <ul>
                                    <li v-for="(item, index) in lugares" :key="index">
                                        <a v-on:click="openLugar(item)">{{ item.nombre }}</a>
                                    </li>
                                </ul>
                            </div>
                            <div class="bloque-ubicaciones__sidebar sidebar-galeria" v-if="openInfo">
                                <a v-on:click="closeLugar()" class="ubicacion-galeria__nombre">{{ lugarSelected.nombre
                                }}</a>
                                <div class="ubicacion-galeria-wrapper">
                                    <div class="slider-galeria-menu">
                                        <div class="slider-contador"></div>
                                        <div class="slider-flechas"></div>
                                    </div>
                                    <Carousel ref="carousel" :items-to-show="1" :mouseDrag="false" class="slider-ubicacion-galeria">
                                        <slide v-for="(item, index) in lugarSelected?.galeria" :key="(index + 1)">
                                            <div class="slider-galeria__item">
                                                <img :src="item" alt="" />
                                            </div>
                                        </slide>
                                        <template #addons v-if="lugarSelected.galeria?.length > 1">
                                            <div class="slider-galeria-menu">
                                                <div class="slider-contador">
                                                    <ul class="slick-dots" role="tablist" style="display: block;">
                                                        <li class="slick-active" role="presentation"><span class="slide-paginacion">{{ currentSlide + 1 }} / {{ lugarSelected.galeria?.length }}</span></li>
                                                    </ul>
                                                </div>
                                                <div class="slider-flechas">
                                                    <button v-on:click="prev" class="slick-prev slick-arrow"
                                                        aria-label="Previous" type="button" aria-disabled="true"
                                                        style="display: block;">Previous</button>
                                                    <button v-on:click="next" class="slick-next slick-arrow"
                                                        aria-label="Next" type="button" aria-disabled="false"
                                                        style="display: block;">Next</button>
                                                </div>
                                            </div>
                                        </template>
                                    </Carousel>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--// Map -->
        <Video :video="video" />
    </div>
</template>
<script>
import 'vue3-carousel/dist/carousel.css';

import Head from '../../Shared/Head.vue'
import Video from "../../Shared/Home/Video.vue"
import EventoBox from '../../Shared/Eventos/EventoBox.vue'
import HeadTurismo from '../../Shared/Turismo/HeadTurismo.vue'
import LugaresBox from '../../Shared/Turismo/LugaresBox.vue'
import { Carousel, Slide, Navigation, Pagination } from 'vue3-carousel';
import VueGoogleMaps from "@fawmi/vue-google-maps";

export default {
    props: {
        lugares: Object,
        espacios: Object,
        eventos: Object,
        video: Object,
    },
    data() {
        return {
            origin_center: { lat: 25.418512, lng: -100.157602 },
            origin_zoom: 10,
            center: { lat: 25.418512, lng: -100.157602 },
            zoom: 10,
            openInfo: false,
            lugarSelected: [],
            openedMarkerID: null,
            currentSlide: 0,
        }
    },
    computed: {
        /*setLugar: function(lugar){
            return lugar;
        }*/
    },
    methods: {
        openLugar: function (lugar) {
            this.lugarSelected = lugar;
            this.openInfo = true;
            this.openMarker(lugar);
        },
        closeLugar: function () {
            this.lugarSelected = [];
            this.openInfo = false;
            this.openMarker(null);
        },
        clickMarker: function (m) {
            if (m != null) {
                this.openLugar(m);
            } else {
                this.closeLugar();
            }
            this.openMarker(m);
        },
        openMarker: function (m) {
            if (m != null) {
                this.openedMarkerID = m.id
                this.center = { lat: m.latitude, lng: m.longitude };
                this.zoom = 15;
            } else {
                this.openedMarkerID = null;
                this.center = this.origin_center;
                this.zoom = this.origin_zoom;
            }
        },
        next: function() {
            this.$refs.carousel.next();
            this.currentSlide = this.$refs.carousel.data.currentSlide;
        },
        prev: function() {
            this.$refs.carousel.prev();
            this.currentSlide = this.$refs.carousel.data.currentSlide;
        },
    },
    components: {
        Head, EventoBox, HeadTurismo, LugaresBox, Video,
        Carousel,
        Slide,
        Navigation,
        Pagination,
        VueGoogleMaps,
    }
}
</script>
<style scoped>
.slider-ubicacion-galeria.slick-slider {
    height: 100%;
    margin-bottom: 0;
}

.slider-ubicacion-galeria.slick-slider .slider-galeria__item {
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
}

.bloque-ubicaciones__sidebar a {
    cursor: pointer;
}

.slider-galeria__item {
    width: 100%;
    padding: 0 !important;
    display: inline !important;
    min-height: 440px !important;
}

.vue-map-container {
    width: 100%;
}

.title-marker {
    font-family: "Raleway", Helvetica, Arial, sans-serif;
    font-size: 15px;
    font-weight: bold;
    /*border-bottom: 1px solid #d4d4d4;*/
    padding-bottom: 7px;
    padding-right: 10px;
}

.desc-marker {
    font-family: "Raleway", Helvetica, Arial, sans-serif;
    font-size: 13px;
    margin-top: 10px;
}

button.gm-ui-hover-effect {
    top: -1px !important;
    right: -1px !important;
}
.slider-galeria-menu{
    background: rgb(0,0,0);
    background: linear-gradient(0deg, rgb(0 0 0 / 81%) 0%, rgba(0,0,0,0) 92%);
    padding: 13px 30px 20px;
}
.slick-arrow{
    background-repeat: no-repeat !important;
    background-size: contain !important;
    transition: none !important;
}
</style>
